import React from 'react'

export default function MarginTop({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M4 13L4 11.5C4 10.3954 4.89543 9.5 6 9.5H14C15.1046 9.5 16 10.3954 16 11.5V13'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M7 6.5H13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
